var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_facebook")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook_Circle",
    "data-name": "Facebook Circle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,0A22,22,0,1,0,44,22,22,22,0,0,0,22,0Zm0,42A20,20,0,1,1,42,22,20,20,0,0,1,22,42Zm2-24.75c0-.81.08-1.24,1.33-1.24H27V13H24.32C21.12,13,20,14.5,20,17V19H18v3h2v9h4V22h2.67L27,19H24Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_facebook.77d6f2c7.svg";
export { ForwardRef as ReactComponent };